import Container from './partner-sub-navigation-container';

export default Container;
